/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_eLab/helpers'

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <>
<div
  className='d-flex justify-content-center align-items-center bgi-no-repeat bgi-size-cover'
  style={{
    minHeight: '100vh',
    // backgroundImage: `url(${toAbsoluteUrl('/media/img/bg_11.png')})`,
    backgroundImage: `url(${toAbsoluteUrl('/media/img/bgimg2.jpg')})`,
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    padding: '20px 0' // Added padding for mobile
  }}
>
<div className='container-fluid px-0'>
    <div className='row g-0 justify-content-center align-items-stretch' style={{ maxWidth: '1000px', margin: '0 auto' }}>
      {/* Left Side - Image Section (Now visible on all devices) */}
      <div className='col-md-5 col-12 p-0 position-relative order-md-1 order-2'>
        <div className='position-absolute w-100 h-200' style={{
          background: 'linear-gradient(135deg, rgba(25,115,56,0.15) 0%, rgba(19,84,42,0.3) 100%)',
          zIndex: 1,
          borderRadius: '10px 0 0 10px'
        }}></div>
        <img
          src={toAbsoluteUrl('/media/img/lab-side-img.png')}
          alt='Login Visual'
          className='img-fluid w-100'
          style={{
            objectFit: 'cover',
            height: '100%',
            minHeight: '300px', // Reduced for mobile
            boxShadow: '10px  10px 10px 10px rgba(61, 198, 216, 0.3)', // Increased shadow here
            borderRadius: '10px 0 0 10px',
          }}
        />
      </div>

      {/* Right Side - Login Form */}
      <div
        className='col-md-5 col-12 p-0 order-md-2 order-1'
        style={{
          minHeight: 'auto',
        }}
      >
        <div className='h-100 bg-white p-4 p-lg-5 d-flex flex-column justify-content-center'
          style={{
            borderRadius: '0 10px 10px 0',
            boxShadow: '0 20px 50px rgba(61, 198, 216, 0.3)', // Increased shadow here
            position: 'relative', // Added for better shadow rendering
            zIndex: 2, // Ensure shadow appears above other elements
          }}
        >
          <div className='text-center mb-4'>
            <img 
              src={toAbsoluteUrl('/media/logos/LLC_logo_New.jpeg')} 
              alt="Company Logo" 
              style={{height: '100px'}}
              // className='mb-3'
            />
          </div>

          <div style={{maxWidth: '350px', margin: '0 auto', width: '100%'}}>
            <Switch>
              <Route path='/auth/login' component={Login} />
              <Route path='/auth/registration' component={Registration} />
              <Route path='/auth/forgot-password' component={ForgotPassword} />
              <Redirect from='/auth' exact={true} to='/auth/login' />
              <Redirect to='/auth/login' />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    </>
  )
}
